class CartUpsellHandler extends HTMLElement {
  constructor() {
    super();
    this.upsellForms = [];
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) return;

    this.upsellForms = cartDrawer.querySelectorAll(".upsell_form");
    this.upsellForms.forEach((form) => {
      form.addEventListener("submit", (e) => this.onSubmit(e, form));
    });
  }

  onSubmit(event, form) {
    event.preventDefault();
    event.stopPropagation();

    const submitButton = form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.classList.add("loading");
    }

    const formData = new FormData(form);
    formData.append("sections", "cart-drawer");

    fetch(`${Shopify.routes.root}cart/add.js`, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then(() => {
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );
      })
      .catch((err) => console.error("Upsell Add to Cart failed:", err))
      .finally(() => {
        if (submitButton) {
          submitButton.classList.remove("loading");
        }
      });
  }
}

// Register the element
customElements.define("cart-upsell-handler", CartUpsellHandler);

// Re-init on cart:refresh
document.addEventListener("cart:refresh", () => {
  const existing = document.querySelector("cart-upsell-handler");
  if (existing) {
    existing.init();
  }
});
